import { Nullable } from 'primeng/ts-helpers';

import { NgTemplateOutlet } from '@angular/common';
import { Component, QueryList, TemplateRef, ContentChildren, AfterContentInit, ViewEncapsulation } from '@angular/core';

import { AppTemplateDirective } from '@/app/shared/directives/app-template.directive';

import { AppDialogRef, BaseDialogComponent } from '@/app/shared/components/ui/dialog';
import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon/svg-icon.component';
import { DialogTitleComponent } from '@/app/shared/components/ui/dialog/elements/dialog-title/dialog-title.component';

@Component({
  selector: 'app-dialog-header',
  standalone: true,
  imports: [SvgIconComponent, DialogTitleComponent, NgTemplateOutlet, SvgIconComponent],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-dialog-header',
  },
})
export class DialogHeaderComponent implements AfterContentInit {
  customHeaderTemplate: Nullable<TemplateRef<any>>;

  @ContentChildren(AppTemplateDirective) templates: Nullable<QueryList<AppTemplateDirective>>;

  constructor(private dialogRef: AppDialogRef<BaseDialogComponent<any, any>>) {}

  ngAfterContentInit() {
    (this.templates as QueryList<AppTemplateDirective>).forEach((item) => {
      switch (item.getType()) {
        case 'customTemplate':
          this.customHeaderTemplate = item.template;
          break;
      }
    });
  }

  closeDialog() {
    this.dialogRef.cancel();
  }
}
